import React from 'react';

import { IconError } from '../../foundations/Iconography/IconError';
import * as styles from './Feedback.styles';

type Alignment = 'left' | 'right';

export interface InputFeedback {
  error?: boolean;
  iconAlign?: Alignment;
  id?: string;
  name?: string;
  value?: string | number;
}

export const Feedback = ({ error, iconAlign: align, id, name, value = '' }: InputFeedback) => (
  <>
    {!!name && (
      <span css={styles.feedbackName} data-has-error={!!error} id={id}>
        <span css={styles.errorField} data-icon-align={align}>
          {name}
          {align === 'left' && <IconError css={styles.errorIconLeft} height={16} width={16} />}
        </span>
      </span>
    )}
    <span css={styles.feedbackValue} data-has-error={!!error}>
      <span css={styles.errorField} data-icon-align={align}>
        {value}
        {align === 'right' && <IconError css={styles.errorIconRight} height={16} width={16} />}
      </span>
    </span>
  </>
);
